{
  "feedback": {
    "bad": "Bad",
    "good": "Good",
    "excellent": "Excellent",
    "heading": "Did you enjoy?",
    "placeholder": "Your feedback (optional)",
    "button": "Send feedback"
  },
  "tips": "Tips",
  "receipts_total": "Receipt's total: {{total}}",
  "error": {
    "general": {
      "title": "Something went wrong",
      "description": "Sorry, but we encountered an error. Please try to refresh the page"
    }
  },
  "fee": {
    "title": "Cover processing fee?",
    "description": "When you tip by card there are fees to pay the card issuer. We do our best to make it as low as possible.",
    "receive": "{{name}} will receive <b>{{amount}}</b>",
    "charge": "You will be charged for <b>{{amount}}</b>"
  },
  "success": {
    "feedback": {
      "description": [
        "We truly appreciate your feedback! Thank you for taking the time to share your thoughts with us.",
        "Thank you for your valuable feedback! Your input helps us improve and serve you better.",
        "Wow, thank you for your insightful feedback! We're grateful for your honesty and suggestions.",
        "From all of us here, a heartfelt thank you for your feedback! We're committed to using it to make positive changes.",
        "Thank you for sharing your feedback with us! Your perspective is invaluable to us.",
        "Your feedback means a lot to us! Thank you for helping us understand how we can do better.",
        "Thanks a million for your feedback! We appreciate your contribution to making our service even better.",
        "Your feedback has made our day! Thank you for your thoughtful input and suggestions.",
        "We're sending a big thank you your way for your feedback! It helps us continue improving and growing.",
        "Thank you for your feedback and for being a part of our community! Your insights help shape our future."
      ],
      "title": "Thank you! ❤️"
    },
    "tip": {
      "description": [
        "We truly appreciate your generosity! Thank you for tipping and supporting our team.",
        "Thank you for your kindness and support! Your tip means the world to us.",
        "Wow, thank you for your incredible generosity! Your tip is deeply appreciated.",
        "From all of us here, a heartfelt thank you for your tip! We're grateful for your support.",
        "Thank you for being so generous with your tip! Your kindness doesn't go unnoticed.",
        "Your tip brightened our day! Thank you for your thoughtfulness and support.",
        "Thanks a million for your tip! Your generosity helps us continue doing what we love.",
        "Your tip has made our day! Thank you for your support and kindness.",
        "We're sending a big thank you your way for your generous tip! It means a lot to us.",
        "Thank you for your tip and for being a part of our community! Your support keeps us going."
      ],
      "emailsent": "We have sent a receipt to email",
      "title": "Thank you! ❤️",
      "receipt": "Click here to get a receipt of transaction",
      "email": "Email",
      "send": "Send",
      "download": "Or <clickhere>click here</clickhere> to download it"
    }
  },
  "forbidden": {
    "title": "Sorry ❤️",
    "description": "Tipping is not active at the moment — check back soon! If you would like to leave a feedback <clickhere>click here</clickhere>"
  },
  "pay": "Pay {{amount}}",
  "org": {
    "tipstovenue": "Leave tips to venue, tips will be shared across workers",
    "tipsquestion": "Who do you like to leave a tips?",
    "workers": "Workers"
  }
}
